import _ from "lodash";

const operationMessages = {
    create: "Create domain data record failed",
    update: "Update domain data record failed",
    delete: "Delete domain data record failed",
};

export default function normalizeDomainDataError(error, operation) {
    const status = error?.response?.status;
    const responseData = error?.response?.data;
    const responseError = responseData && typeof responseData === "object" && !Array.isArray(responseData) ? responseData : {};
    const outcomeUncertain = Boolean(error?.isAxiosError && (!error.response || status >= 500));

    let result = {
        code: error?.code || "failed",
        message: error?.message || operationMessages[operation] || "Domain data mutation failed",
        ...(status ? { status } : {}),
        ...responseError,
        ...(outcomeUncertain ? { outcomeUncertain: true } : {}),
    };

    if (status === 403 && !responseError.code) {
        result.code = "PERMISSION_DENIED";
        result.message = "Permission denied";
    } else if (status === 404 && !responseError.code) {
        result.code = "NOT_FOUND_ERROR";
        result.message = "Resource not found";
    }

    if (result.fields && result.fields.length > 0) {
        result.fields = result.fields.reduce((fieldErrors, field) => {
            fieldErrors[field.name] = _.isArray(field.errors) ? field.errors.join("\n") : field.errors;
            return fieldErrors;
        }, {});
    }

    return result;
}
